import PropTypes from "prop-types";
import React from "react";

// Decorative diagrams, not representations of experimental data.
export default function ScienceArt({ kind }) {
  return (
    <svg
      className={`science-art science-art-${kind}`}
      viewBox="0 0 280 250"
      fill="none"
      aria-hidden="true"
    >
      <g stroke="currentColor" strokeWidth="0.8">
        {kind === "cell" ? (
          <>
            <ellipse
              cx="152"
              cy="132"
              rx="82"
              ry="93"
              transform="rotate(-25 152 132)"
              fill="currentColor"
              fillOpacity=".035"
            />
            <ellipse cx="152" cy="132" rx="75" ry="85" transform="rotate(-25 152 132)" />
            {[
              [130, 80, 20],
              [177, 83, 19],
              [108, 127, 22],
              [155, 128, 24],
              [196, 128, 17],
              [128, 176, 22],
              [177, 176, 22],
            ].map(([x, y, r]) => (
              <g key={x + ":" + y}>
                <circle cx={x} cy={y} r={r} fill="currentColor" fillOpacity=".06" />
                <circle cx={x + 3} cy={y - 2} r={r * 0.38} />
                <circle cx={x - 5} cy={y + 5} r="2" />
              </g>
            ))}
            <path d="M75 235C100 169 209 115 238 15M90 226C65 170 65 97 78 44M203 207C232 159 247 103 241 48" />
            <ellipse
              cx="155"
              cy="136"
              rx="118"
              ry="36"
              transform="rotate(-48 155 136)"
              strokeDasharray="3 6"
            />
          </>
        ) : (
          <>
            <g transform="rotate(32 160 125)">
              {[1, -1].map((direction) => (
                <path
                  key={direction}
                  strokeWidth="1.5"
                  d={Array.from({ length: 85 }, (_, i) => {
                    const t = i / 84;
                    return `${i ? "L" : "M"}${160 + direction * 47 * Math.sin(t * Math.PI * 3)} ${
                      15 + t * 220
                    }`;
                  }).join(" ")}
                />
              ))}
              {Array.from({ length: 23 }, (_, i) => {
                const t = i / 22,
                  offset = 47 * Math.sin(t * Math.PI * 3),
                  y = 15 + t * 220;
                return (
                  <path key={i} d={`M${160 - offset} ${y}H${160 + offset}`} strokeOpacity=".6" />
                );
              })}
            </g>
            {Array.from({ length: 15 }, (_, i) => (
              <path
                key={i}
                d={`M${55 + i * 14} 245v-${12 + ((i * 29) % 67)}`}
                strokeOpacity=".45"
              />
            ))}
          </>
        )}
        {[
          [45, 65],
          [232, 204],
          [82, 203],
          [212, 43],
          [58, 170],
        ].map(([x, y]) => (
          <circle key={x} cx={x} cy={y} r="2.5" fill="currentColor" stroke="none" />
        ))}
      </g>
    </svg>
  );
}

ScienceArt.propTypes = {
  kind: PropTypes.oneOf(["cell", "dna"]).isRequired,
};
